import { StateCreator } from 'zustand';
import { CustomDataPayload } from '@/features/gtm/internal/types/gtm-datalayer';

export interface GTMSlice {
  gtmCustomDataInitialized: boolean;
  gtmCustomData: CustomDataPayload | undefined;
  gtmSetCustomData: (payload: CustomDataPayload) => void;

  gtmSessionFlags: Record<string, true>;
  gtmHasSentThisSession: (key: string) => boolean;
  gtmMarkSentThisSession: (key: string) => void;
}

const SESSION_KEY = 'gtm:sessionFlags';

const readSessionFlags = (): Record<string, true> => {
  if (typeof window === 'undefined') return {};
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    return raw ? (JSON.parse(raw) as Record<string, true>) : {};
  } catch {
    return {};
  }
};

const writeSessionFlags = (flags: Record<string, true>) => {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(flags));
  } catch {
    // ignore storage errors
  }
};

export const createGTMSlice: StateCreator<GTMSlice> = (set, get) => ({
  gtmCustomDataInitialized: false,
  gtmCustomData: undefined,

  gtmSetCustomData: (payload) => {
    set(
      (state) => ({
        gtmCustomData: {
          ...state.gtmCustomData,
          ...payload,
        },
        gtmCustomDataInitialized: true,
      }),
      false,
    );
  },

  gtmSessionFlags: readSessionFlags(),

  gtmHasSentThisSession: (key) => {
    const flags = get().gtmSessionFlags;
    return flags[key];
  },

  gtmMarkSentThisSession: (key) => {
    set((state) => {
      const next = { ...state.gtmSessionFlags, [key]: true as const };
      writeSessionFlags(next);
      return { gtmSessionFlags: next };
    }, false);
  },
});
